module.exports = __webpack_public_path__ + "img/drizzle.366aabb7.svg";